import React, { useEffect, useState } from "react";
import Icon from "@components/AppIcon";

const MissionVisionSection = () => {
  const [missionVision, setMissionVision] = useState([]);

  useEffect(() => {
    const fetchMissionVision = async () => {
      try {
        const res = await fetch("/api/about_us");
        const data = await res.json();

        if (Array.isArray(data) && data.length > 0) {
          const aboutEntry = data[0]; // first About Us entry
          const sections = aboutEntry.sections || [];

          // find the our_mission_vision block AND ensure it's enabled
          const mvSection = sections.find(
            (s) => s.type === "our_mission_vision" && s.enabled
          );

          if (mvSection && mvSection.our_mission_vision) {
            const items = mvSection.our_mission_vision
              .filter((item) => item.enabled) // ✅ only enabled items
              .map((item) => ({
                title: item.title,
                description: item.description?.[0]?.content?.[0]?.text || "",
              }));

            setMissionVision(items);
          }
        }
      } catch (error) {
        console.error("Error fetching mission & vision:", error);
      }
    };

    fetchMissionVision();
  }, []);

  if (missionVision.length === 0) {
    return null; // hide section entirely if nothing enabled
  }

  return (
    <section className="my-20">
      <div className="bg-white rounded-3xl p-8 lg:p-12 medical-shadow">
        <div className="text-center mb-12">
          <h3 className="font-heading font-bold text-2xl lg:text-3xl text-[#08005f] mb-4">
            Our Mission & Vision
          </h3>
          <p className="text-text-secondary leading-relaxed max-w-2xl mx-auto">
            Guided by purpose and passion, we strive to transform eye care in Kenya and
            beyond. Our mission and vision reflect our unwavering commitment to accessible,
            innovative, and compassionate vision health for all.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {missionVision.map((item, index) => (
            <div
              key={index}
              className="bg-[#f5f6fa] rounded-xl p-8 text-center hover:bg-[#e8eafd] hover:medical-shadow medical-transition flex flex-col items-center border border-[#08005f]/10"
            >
              <div className="w-16 h-16 bg-[#08005f]/10 rounded-2xl flex items-center justify-center mb-4">
                <Icon
                  name={item.title.includes("Mission") ? "Target" : "Eye"}
                  size={32}
                  color="#08005f"
                  strokeWidth={2}
                />
              </div>
              <h4 className="font-heading font-semibold text-xl text-[#08005f] mb-3">
                {item.title}
              </h4>
              <p className="text-text-secondary text-base leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;
